import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center">
      <h1 className="mb-6 font-serif text-7xl font-semibold text-foreground md:text-8xl">404</h1>
      <p className="mb-2 font-serif text-2xl text-foreground">This page doesn't exist.</p>
      <p className="mb-8 max-w-sm text-body text-muted-foreground">
        But the people you love do. Head back and show up for them.
      </p>
      <Button onClick={() => navigate("/")} size="lg">
        Back to Dearestly →
      </Button>
    </div>
  );
};

export default NotFound;
